import * as React from "react";
import {
    PlasmicNoteList,
    DefaultNoteListProps
} from "./plasmic/main/PlasmicNoteList";
import ListElement from "./ListElement";
import {Note} from "../models/fauna/dbSchema";
import {useEffect, useState} from "react";
import {getNoteTitle} from "./NoteViewer";

export interface NoteListProps extends DefaultNoteListProps {
    notes: Note[],
    displayedNote: Note,
    jumpAndEditNote: (note: Note) => void
}

function NoteList({notes, displayedNote, jumpAndEditNote, ...rest}: NoteListProps) {
    const [state, setState] = useState<"empty" | undefined>();
    useEffect(() => setState(notes.length ? undefined : "empty"), [notes]);
    return <PlasmicNoteList
        state={state}
        noteList={{
            children: notes.map((note) => <ListElement
                name={getNoteTitle(note)}
                action={() => jumpAndEditNote(note)}
                selected={note === displayedNote}
            />)
        }}
        {...rest} />;
}

export default NoteList;
